import Title from '../layout/Title';
import Card2 from './Card2';
import Card3 from './Card3';
import Card4 from './Card4';
import Card5 from './Card5';
import Card6 from './Card6';
import Card7 from './Card7';
import Card8 from './Card8';
import Card9 from './Card9';
import Card10 from './Card10';
import Card11 from './Card11';
import ProjectCards from './ProjectCards';
import Card12 from './Card12';

const Project = () => {
  return (
    <section
      id='project'
      className='w-full py-20 border-b-[1px] border-b-black'
    >
      <div className='flex justify-center items-center text-center'>
        <Title
          title='VISIT MY PORTFOLIO AND GIVE YOUR FEEDBACK'
          des='My Projects'
        />
      </div>
      <div className='grid px-6 grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6 xl:gap-14'>
        <ProjectCards
          title='Amebo Socials'
          des='A Social media app that lets you create post, delete and update posts, follow users and like posts. Has Dark and Light Mode feature. Built with React, Redux, Nodejs, Tailwindcss, mongodb, Expressjs, etc.'
        ></ProjectCards>
        <Card2
          title='Air Raid'
          des='A fun 2D FPS mobile game application for people of all ages. Built with Java, Android Studio, etc. Compatible with android version 6+'
        />
        <Card11
          title='Arone Tech'
          des='Developed a responsive company website showcasing all services and departments using React and TailwindCSS, with EmailJS integration for seamless client communication.'
        />
        <Card3
          title='Simple Calc. App'
          des='A simple calculator with basic math functions like Addition, Subtraction, Multiplication and Division. Built with Java, Android Studio, etc.'
        />

        <Card6
          title='Client Portfolio Web'
          des='Developed a responsive portfolio website for a client using React, TailwindCSS, and Vite, with EmailJS integration for seamless contact form functionality.'
        />

        <Card7
          title='Amebo Chat'
          des='Built a full-stack real-time chat app with personal and group messaging features, leveraging Node.js, React, Vite, TailwindCSS, MongoDB, and Socket.IO.'
        />

        <Card8
          title='Qview AI'
          des='Built a smart security web app with live camera integration, real-time video and sound analysis, and automation using ML services. Developed with ReactJS, Flask, and MongoDB, featuring Google Maps and Cloud Storage integration, FFmpeg for video processing, and deployed on Hetzner with Nginx'
        />

        <Card4
          title='Video Editing'
          des='Produce high-quality, professional videos with Adobe Premiere Pro, Canva, CapCut, InShot, and other tools, delivering sharp visuals, great sound, and seamless edits.'
        />
        <Card5
          title='Yespedite'
          des='Developed a job application assistance web app using React, Node.js, Vite, TailwindCSS, and MongoDB. Integrated Google Forms and Sheets APIs to collect, manage, and organize user details, streamlining the job application process.'
        />
        <Card9
          title='HooBank'
          des='Designed and built a simple banking/payment web application focused on a clean, modern, and user-friendly interface, ensuring seamless navigation and intuitive user experience.'
        />
        <Card10
          title='Arone Energy'
          des='Built a highly responsive web application for Luminar, a solar inverter product sales platform, using React and TailwindCSS. The site delivers a clean UI, smooth navigation, and an optimized shopping experience across all devices.'
        />
        <Card12
        title='Aurora'
        des='Developed a responsive drone company website using React.js and Tailwind CSS, hosted on a Hetzner Linux server with Nginx and SSL for optimized performance and security.'
        />
      </div>
      
    </section>
  );
};
export default Project;
